<button
  type="button"
  mat-icon-button
  (click)="clickOpen($event)"
>
  <mat-icon>more_vert</mat-icon>
</button>
